// extracted by mini-css-extract-plugin
export default {"warningBanner":"ixOI2zmjTmq1tka4CkRu"};